import "regenerator-runtime/runtime";
import EnvRoutesService from "./routes";
import axios from "axios";
import { EventBus } from "./event-bus";
import { OAuth } from "./oauth/oauth.js";
import * as views from "./views";
// console.log(documen)
/*
 * This code is to test the document referrer and build out the logo switching
 */

let isStaging = false;

// Check if we're in staging environment and automatically enable the forgot password button and hide captcha
async function checkEnvironment() {
   try {
      const routes = await EnvRoutesService.getRoutes();
      isStaging = routes.backendAuthServer && routes.backendAuthServer.includes("staging");

      if (isStaging) {
         if (document.getElementById("forgotPwBtn")) {
            document.getElementById("forgotPwBtn").disabled = false;
         }
         if (document.getElementById("captchaContainer")) {
            document.getElementById("captchaContainer").style.display = "none";
         }
      }
   } catch (error) {
      console.error("Error determining environment:", error);
   }
}

document.addEventListener("DOMContentLoaded", () => {
   checkEnvironment();
});

const eventBus = new EventBus();

const MOBILE_REDIRECT_ROUTE = "/mobileDashboard";
const USE_NEW_PW_EXPIRED = true;

const isESignatureVerification = window.location.pathname === "/esignature-verification";
const isOAuth = window.location.pathname.includes("/interaction");
if (isOAuth) {
   new OAuth(eventBus);
}

// This is a workaround for SSO logins. I don't have access to the
// cookies from the ssoLogin route, so we send the user back here
// and check if they are already logged in, then run the OIDC flow.
if (window.location.search.includes("checkLoggedIn=true")) {
   EnvRoutesService.getRoutes().then((routes) => {
      axios
         .post(`${routes.backendAuthServer}/verify`)
         .then((response) => {
            console.log("devLog: response", response);
            if (response.data.success) {
               eventBus.publish("login", {
                  success: true,
                  user: response.data.userID,
                  username: response.data.userLoginName,
               });
            }
         })
         .catch((error) => {
            console.error("devLog: error", error);
         });
   });
}

document.getElementById("loginBtn").addEventListener("click", function () {
   submitLogin();
});

document.getElementById("loginForm").addEventListener(
   "keydown",
   function (event) {
      if (event.key == "Enter") {
         submitLogin();
      }
   },
   false
);

document.getElementById("forgotPwBtn").addEventListener("click", function () {
   forgotMyPassword();
});
/*

   On page load we should check for the exsitance of a cookie and redirect the user if they have one? Maybe.

*/

let userField = "system_processor"; //these names are specifically misleading
let passField = "limble_region"; //these names are specifically misleading

let creds = getLoginLocalStorage(userField, passField);
if (creds.user && creds.pass) {
   document.getElementById("username").value = creds.user;
   document.getElementById("password").value = creds.pass;
   document.getElementById("box3").checked = true;
}

function submitLogin() {
   //IN THE FUTURE BEFORE WE POST TO THE LOGIN SERVER WILL NEED TO POST TO THE AUTH SERVER LOCATED IN N.CALI
   //THAT AUTH SERVER WILL HAVE TO RETURN WHICH REGION THE ACCOUNT IS IN BASED ON A HASH DATABASE/Dynamo
   // grecaptcha.ready(function () {
   //    grecaptcha
   //       .execute("6LeyXOAUAAAAAIEfLKdFbTscOgqtl34_M1cSWK09", { action: "login" })
   //       .then(function (token) {

   if (document.getElementById("username").value && document.getElementById("password").value) {
      login();
   } else {
      document.getElementById("loginErr").style.display = "";
      document.getElementById("loading").style.display = "none";
      setAllLogoDisplays("");
      return;
   }
   // });
   // });
}

async function submitPasswordUpdate() {
   setAllLogoDisplays("none");
   document.getElementById("loading").style.display = "flex";
   try {
      const validCurrentPassword = await verifyCurrentPassword();

      if (validCurrentPassword) {
         const updateSuccessful = await updatePassword();

         if (updateSuccessful) {
            showUpdateSuccess();
         } else {
            showUpdateError();
         }
      } else {
         showCurrentPasswordValidationError();
      }
   } catch (error) {
      showUpdateError();
   } finally {
      document.getElementById("loading").style.display = "none";
      setAllLogoDisplays("");
   }
}

function setAllLogoDisplays(displayCode = "") {
   var logos = document.getElementsByClassName("logo");
   for (var i = 0; i < logos.length; ++i) {
      var item = logos[i];
      item.style.display = displayCode;
   }
}

async function verifyCurrentPassword() {
   try {
      const routes = await EnvRoutesService.getRoutes();
      let config = {
         headers: { "Access-Control-Allow-Origin": routes.backendAuthServer },
         withCredentials: true,
      };
      const response = await axios.post(
         routes.backendAuthServer + "/verifyCurrentPassword",
         {
            username: document.getElementById("username").value,
            currentPassword: document.getElementById("currentPassword").value,
         },
         config
      );
      return response.data.success;
   } catch (error) {
      return false;
   }
}

async function updatePassword() {
   try {
      const routes = await EnvRoutesService.getRoutes();
      let config = {
         headers: { "Access-Control-Allow-Origin": routes.backendAuthServer },
         withCredentials: true,
      };
      const response = await axios.post(
         routes.backendAuthServer + "/updatePassword",
         {
            username: document.getElementById("username").value,
            currentPassword: document.getElementById("currentPassword").value,
            newPassword: document.getElementById("newPassword").value,
            confirmNewPassword: document.getElementById("confirmNewPass").value,
         },
         config
      );
      return response?.data?.success ? true : false;
   } catch (error) {
      return false;
   }
}

function showUpdateSuccess() {
   // Show the success message div
   const messageDiv = document.getElementById("updatePasswordMessage");
   messageDiv.style.display = "block";
   messageDiv.style.color = "#14AE5C";
   messageDiv.textContent = document.lang.PasswordSuccessfullyUpdatedLoginAgain;

   // Reset the form and show login
   document.getElementById("newPwExpired").style.display = "none";
   document.getElementById("loginForm").style.display = "";
   document.getElementById("signUpDiv").style.display = "";
   document.getElementById("legalTermsSection").style.display = "";

   // Clear the password fields
   document.getElementById("password").value = "";
   document.getElementById("currentPassword").value = "";
   document.getElementById("newPassword").value = "";
   document.getElementById("confirmNewPass").value = "";
}

function showUpdateError() {
   const messageDiv = document.getElementById("updatePasswordMessage");
   messageDiv.style.display = "block";
   messageDiv.style.color = "#FF0000";
   messageDiv.textContent = document.lang.ErrorUpdatingPasswordContactSupport;
}

function showCurrentPasswordValidationError() {
   const currentPasswordElement = document.getElementById("currentPassword");
   const errorElement = document.getElementById("currentPasswordFieldError");
   const wrapperElement = currentPasswordElement.closest(".wrap-input");

   errorElement.style.display = "";
   errorElement.textContent = "Current Password is incorrect";
   wrapperElement.classList.toggle("has-error", true);
}

function login() {
   document.getElementById("loading").style.display = "flex";
   setAllLogoDisplays("none");
   document.getElementById("loginErr").style.display = "none";

   return EnvRoutesService.getRoutes().then((routes) => {
      //post to N.cali auth server to find out which region
      let config = {
         headers: { "Access-Control-Allow-Origin": routes.backendAuthServer },
         withCredentials: true,
      };
      axios
         .post(
            (() => {
               const params = new URLSearchParams(window.location.search);
               const redirectUrlParam = params.get("redirect_uri");
               const base = routes.backendAuthServer + "/login";
               return redirectUrlParam
                  ? `${base}?redirect_uri=${encodeURIComponent(redirectUrlParam)}`
                  : base;
            })(),
            {
               username: document.getElementById("username").value,
               password: document.getElementById("password").value,
               isMobile: checkMobile(),
               isLegacyMobileApp: isLegacyMobileApp(),
            },
            config
         )
         .then(function (response) {
            if (response.data.success) {
               // console.log(response.data);
               setCookie("languageCookie", getCookie("languageCookie"), 365);
               //save pass info here.
               const box3 = document.getElementById("box3");
               if (box3 && box3.checked) {
                  setLoginLocalStorage(
                     document.getElementById("username").value,
                     document.getElementById("password").value
                  );
               } else {
                  clearLoginLocalStorage(userField, passField);
               }

               deleteUnusedCookies(response.data.link);

               /*
                  The server is going to have to return the URL they should be directed to..... Only it can know what creds each user has...
               */
               //if there is a document.referrer then they came here un-authenticated from an app subdomain so save that and once logged in shoot them over to where they were trying to go
               //catch if there is a document referrer. This is for white label customers. If they are a white label customer their subdomain will point to the app server, if they are not logged in they will be forwarded to auth.limblecmms.com where the logo will get replaced based on document referrer, and this will send them to their sub-domain app server
               // if (
               //    document.referrer.includes(".limblecmms.com") &&
               //    !document.referrer.includes("https://limblecmms.com") &&
               //    !document.referrer.includes("https://www.limblecmms.com")
               // ) {
               //This needs to be a bit smarter for white label customers and direct them to the page they have access to, but also the white label domain. Find a way to do this without string replacing... hopefully.
               //    window.location.href = document.referrer;
               // } else {
               if (isESignatureVerification) {
                  window.sessionStorage.removeItem("loginAttemptNumber");
                  window.parent.postMessage(
                     {
                        success: true,
                        user: response.data.user,
                     },
                     routes.appUrl
                  );
               } else if (isOAuth) {
                  // OAuth is using the event bus to handle this case, the others should follow the same pattern eventually
               } else {
                  const redirectUrl = evaluateRedirectUri(response.data.link);
                  navigateToApp(redirectUrl);
               }
               // }
               //if remember me was checked then store their username and password in a cookie

               eventBus.publish("login", response.data);
            } else if (response.data.success == false && response.data.pwExpired == true) {
               if (USE_NEW_PW_EXPIRED) {
                  togglePwExpiredVisibility();
                  addEventListenersToPasswords();
               } else {
                  document.getElementById("loading").style.display = "none";
                  //display forgot my password modal with a message telling the user their password expired and will have to reset it via email
                  openModal();
                  document.getElementById("pwExpired").style.display = "";
               }
            } else {
               //display message saying login failed
               setAllLogoDisplays("none");
               if (!isESignatureVerification) {
                  document.getElementById("errorContainer").classList.add("p-b-32");
               }

               document.getElementById("loginErr").style.display = "";
            }
            // console.log(response, "response from auth server");
         })
         .catch(function (error) {
            setAllLogoDisplays();

            if (!isESignatureVerification) {
               document.getElementById("errorContainer").classList.add("p-b-32");
            }
            document.getElementById("loginErr").style.display = "";
            document.getElementById("loading").style.display = "none";

            if (document.getElementById("ssoProviderErr")) {
               document.getElementById("ssoProviderErr").style.display = "block";
            }

            // console.log("CATCH ERROR");
            console.log(error);

            if (isESignatureVerification) {
               let loginAttemptNumber = window.sessionStorage.getItem("loginAttemptNumber") ?? 0;

               if (loginAttemptNumber >= 3) {
                  window.sessionStorage.removeItem("loginAttemptNumber");
                  window.parent.postMessage(
                     {
                        success: false,
                        user: 0,
                     },
                     routes.appUrl
                  );
                  return;
               }

               window.sessionStorage.setItem("loginAttemptNumber", ++loginAttemptNumber);
               setElementAttribute("loginAttemptNumber", "innerHTML", loginAttemptNumber);
            }
         });
      //get the region return and post to that region's auth server
   });
}

//forgot my password button clicked here.
function enableForgotPassword() {
   document.getElementById("forgotPwBtn").disabled = false;
}
window.enableForgotPassword = enableForgotPassword;

function forgotMyPassword() {
   document.getElementById("forgotPasswordSuccess").style.display = "none";
   if (document.getElementById("forgotMyPasswordUsername").value) {
      return EnvRoutesService.getRoutes().then((routes) => {
         setAllLogoDisplays("none");
         //post to N.cali auth server to find out which region
         var config = {
            headers: { "Access-Control-Allow-Origin": routes.backendAuthServer },
            withCredentials: true,
         };

         isStaging = routes.backendAuthServer && routes.backendAuthServer.includes("staging");

         const requestData = {
            username: document.getElementById("forgotMyPasswordUsername").value,
            hcaptcha_client_response: isStaging ? "staging-bypass" : hcaptcha.getResponse(),
         };

         axios
            .post(routes.backendAuthServer + "/forgotMyPassword", requestData, config)
            .then(function (response) {
               setAllLogoDisplays();
               document.getElementById("forgotPasswordErrorHandlingStyles").classList.add("p-b-32");
               if (response.data.success) {
                  document.getElementById("forgotPasswordSuccess").style.display = "inline";
               } else {
                  document.getElementById("forgotPasswordSuccess").style.display = "inline";
                  document.getElementById("loginErr").style.display = "none";
               }
               // console.log(response, "response from auth server");

               if (isESignatureVerification) {
                  window.parent.postMessage(
                     {
                        success: null,
                        user: 0,
                     },
                     routes.appUrl
                  );
               }
            })
            .catch(function (error) {
               document.getElementById("forgotPasswordErrorHandlingStyles").classList.add("p-b-32");
               document.getElementById("loginErr").style.display = "";
               console.log(error);
            });
         //get the region return and post to that region's auth server
      });
   } else {
      return;
   }
}

let customerPasswordLength = 8;
let currentPasswordFieldErrors = [];
let newPasswordFieldErrors = [];
let repeatPasswordFieldErrors = [];

function validateCurrentPassword(currentPassword) {
   currentPasswordFieldErrors = [];

   if (!currentPassword) {
      currentPasswordFieldErrors.push(
         document.lang.CurrentPasswordIsBlank ?? "Enter your current password"
      );
      return false;
   }

   return true;
}

function validateNewPassword(newPassword, currentPassword) {
   newPasswordFieldErrors = [];

   if (!newPassword) {
      newPasswordFieldErrors.push(document.lang.NewPasswordIsBlank ?? "Enter your new password");
      return false;
   }

   if (newPassword.length < customerPasswordLength) {
      var errorMessage;
      if (typeof document?.lang?.yourPasswordMustBeAtLeast == "undefined") {
         errorMessage =
            "Your password must be at least this many characters: " + ` ${customerPasswordLength}`;
      } else {
         errorMessage = document.lang.yourPasswordMustBeAtLeast + `: ${customerPasswordLength}`;
      }
      newPasswordFieldErrors.push(errorMessage);
   }

   if (!/^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<~`>/?]*$/.test(newPassword)) {
      newPasswordFieldErrors.push(
         document.lang.PasswordOnlyLettersNumbersCharacters ??
            "Your password can only contain letters, numbers, and special characters."
      );
   }

   if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<~`>/?])/.test(
         newPassword
      )
   ) {
      newPasswordFieldErrors.push(
         document.lang.PasswordMustContainUpperLowerNumberSymbol ??
            "Your password must contain at least one uppercase letter, one lowercase letter, one number, and one special character."
      );
   }

   if (currentPassword && currentPassword === newPassword) {
      newPasswordFieldErrors.push(
         document.lang.YourNewPasswordCannotMatchYourOldPassword ??
            "Your new password cannot match your old password"
      );
   }

   return newPasswordFieldErrors.length === 0;
}

function validateRepeatPassword(repeatPassword, newPassword) {
   repeatPasswordFieldErrors = [];

   if (!repeatPassword) {
      repeatPasswordFieldErrors.push(
         document.lang.ConfirmNewPasswordIsBlank ?? "Enter your new password again"
      );
      return false;
   }

   if (newPassword && newPassword !== repeatPassword) {
      repeatPasswordFieldErrors.push(
         document.lang.NewPasswordsDontMatchReenter ??
            "New passwords do not match. Update and try again."
      );
      return false;
   }

   return true;
}

async function getCustomerPasswordRequirements() {
   if (document.getElementById("username").value) {
      return EnvRoutesService.getRoutes().then((routes) => {
         //post to N.cali auth server to find out which region
         var config = {
            headers: { "Access-Control-Allow-Origin": routes.backendAuthServer },
            withCredentials: true,
         };
         axios
            .post(
               routes.backendAuthServer + "/passwordMinLength",
               {
                  username: document.getElementById("username").value,
               },
               config
            )
            .then(function (response) {
               if (response.data.success) {
                  customerPasswordLength = response.data.pwMinLength;
               } else {
                  customerPasswordLength = 8;
               }
               updatePasswordExpiredLengthWarning(customerPasswordLength);
            })
            .catch(function () {
               customerPasswordLength = 8;
               updatePasswordExpiredLengthWarning(customerPasswordLength);
            });
      });
   } else {
      return;
   }
}

function updatePasswordExpiredLengthWarning(minLength) {
   const lengthWarningSpan = document.getElementById("pwExpiredLengthWarning");
   var errorMessage;
   if (typeof document?.lang?.yourPasswordMustBeAtLeast == "undefined") {
      errorMessage = "Your password must be at least this many characters: " + ` ${minLength}`;
   } else {
      errorMessage = document.lang.yourPasswordMustBeAtLeast + `: ${minLength}`;
   }
   newPasswordFieldErrors.push(errorMessage);

   if (lengthWarningSpan) {
      lengthWarningSpan.textContent = errorMessage;
   }
}

function togglePwExpiredVisibility() {
   document.getElementById("loading").style.display = "none";
   document.getElementById("loginForm").style.display = "none";
   document.getElementById("newPwExpired").style.display = "";
   document.getElementById("signUpDiv").style.display = "none";
   document.getElementById("legalTermsSection").style.display = "none";

   getCustomerPasswordRequirements();
   setAllLogoDisplays("");
}

function setupPasswordVisibilityToggle(toggleId, passwordId) {
   const toggleButton = document.querySelector(`#${toggleId}`);
   const passwordField = document.querySelector(`#${passwordId}`);

   toggleButton?.addEventListener("click", function () {
      const type = passwordField.getAttribute("type") === "password" ? "text" : "password";
      passwordField.setAttribute("type", type);
      this.classList.toggle("fa-eye-slash");
      this.classList.toggle("fa-eye");
   });
}

function addEventListenersToPasswords() {
   const currentPasswordField = document.getElementById("currentPassword");
   const newPasswordField = document.getElementById("newPassword");
   const confirmNewPass = document.getElementById("confirmNewPass");
   const updatePasswordBtn = document.getElementById("updatePasswordBtn");

   if (currentPasswordField && newPasswordField && confirmNewPass) {
      currentPasswordField.addEventListener("blur", function () {
         const isValid = validateCurrentPassword(this.value);
         const errorElement = document.getElementById("currentPasswordFieldError");
         const wrapperElement = this.closest(".wrap-input");

         errorElement.textContent = currentPasswordFieldErrors.join(",\n");
         errorElement.style.display = isValid ? "none" : "";
         wrapperElement.classList.toggle("has-error", !isValid);
      });

      newPasswordField.addEventListener("blur", function () {
         const isValid = validateNewPassword(this.value, currentPasswordField.value);
         const errorElement = document.getElementById("newPasswordFieldError");
         const wrapperElement = this.closest(".wrap-input");

         errorElement.textContent = newPasswordFieldErrors.join(",\n");
         errorElement.style.display = isValid ? "none" : "";
         wrapperElement.classList.toggle("has-error", !isValid);
      });

      confirmNewPass.addEventListener("blur", function () {
         const isValid = validateRepeatPassword(this.value, newPasswordField.value);
         const errorElement = document.getElementById("confirmNewPassFieldError");
         const wrapperElement = this.closest(".wrap-input");

         errorElement.textContent = repeatPasswordFieldErrors.join(",\n");
         errorElement.style.display = isValid ? "none" : "";
         wrapperElement.classList.toggle("has-error", !isValid);
      });

      // Set up toggle functionality for all password fields
      setupPasswordVisibilityToggle("toggleCurrentPassword", "currentPassword");
      setupPasswordVisibilityToggle("toggleNewPassword", "newPassword");
      setupPasswordVisibilityToggle("toggleConfirmNewPass", "confirmNewPass");

      // turn on the update password button
      updatePasswordBtn.addEventListener("click", function (e) {
         e.preventDefault();

         const isCurrentPasswordValid = validateCurrentPassword(currentPasswordField.value);
         const isNewPasswordValid = validateNewPassword(
            newPasswordField.value,
            currentPasswordField.value
         );
         const isConfirmPasswordValid = validateRepeatPassword(
            confirmNewPass.value,
            newPasswordField.value
         );

         if (isCurrentPasswordValid && isNewPasswordValid && isConfirmPasswordValid) {
            // All validations passed, proceed with password update
            submitPasswordUpdate(currentPasswordField.value, newPasswordField.value);
         }
      });
   }
}

/*

WHITE LABEL CUSTOMERS BASED ON REFERRER.... They will be forwarded to auth.limblecmms.com if they go do their sub-domain without an auth cookie

IT IS VERY IMPORTANT THAT ALL WHITE LABEL CUSTOMERS ARE LISTED HERE AND HAVE THEIR LOGO IN

*/
//White label logo imports
import limble from "url:../logos/LimbleLogo.svg";
import DHLLogo from "url:../logos/DHL.png";
import neutron from "url:../logos/neutron-light-background.png";
import enco from "url:../logos/enco.png";
import deliverEZ from "url:../logos/Deliverez_Logo_New_NoBG.png";
import epicGames from "url:../logos/epicGames.png";
import iotPlus from "url:../logos/iotplus-light-background.png";
import invata from "url:../logos/invata-light-background.png";
import netswat from "url:../logos/netswat.png";
import demirer from "url:../logos/demirer-hodling.png";
import scandinaviandrone from "url:../logos/Scandinavian-Drone-Logo-svart.png";
import ComstockFS from "url:../logos/2D-Comstock-Logo.jpg";
import harriganLogo from "url:../logos/HarriganLogo.png";
import sentegrityLogo from "url:../logos/sentegrity.png";
import dartbrookLogo from "url:../logos/Dartbrook_logo.svg";
import redaptiveLogo from "url:../logos/redaptive_logo.svg";
import swoosh from "url:../icons/LoginScreenSwoosh.svg";
import johndeereLogo from "url:../logos/johndeere_logo.png";
import KULogo from "url:../logos/KU.svg";
import homeFixLogo from "url:../logos/homeFixLogo.svg";
import intelsat from "url:../logos/intelsat.svg";
import jbm from "url:../logos/jbm.svg";
import access from "url:../logos/access.svg";
import canyonRidgeServicesLogo from "url:../logos/canyonRidgeServices-light.svg";
import watermarkFacilitiesLogo from "url:../logos/watermark-facilities-logo.svg";
import oregonFoodBankLogo from "url:../logos/OFB_logo_black.png";
import gbcLogo from "url:../logos/germantown-baptist-church.png";
import tqlLogoBlack from "url:../logos/TQL_black.png";

let src = limble;

function checkWhiteLabelDomainMatch(domain) {
   if (document.referrer.includes(domain)) {
      return true;
   } else if (getCookie("whiteLabelSubDomain").includes(domain)) {
      return true;
   } else {
      return false;
   }
}

if (checkWhiteLabelDomainMatch("dhl.limblecmms.com")) {
   src = DHLLogo;
} else if (checkWhiteLabelDomainMatch("neutron.limblecmms.com")) {
   src = neutron;
} else if (checkWhiteLabelDomainMatch("enco.limblecmms.com")) {
   src = enco;
} else if (checkWhiteLabelDomainMatch("deliver-ez.limblecmms.com")) {
   src = deliverEZ;
} else if (checkWhiteLabelDomainMatch("epic.limblecmms.com")) {
   src = epicGames;
} else if (checkWhiteLabelDomainMatch("iotplus.limblecmms.com")) {
   src = iotPlus;
} else if (checkWhiteLabelDomainMatch("invata.limblecmms.com")) {
   src = invata;
} else if (checkWhiteLabelDomainMatch("netswat.limblecmms.com")) {
   src = netswat;
} else if (checkWhiteLabelDomainMatch("demirer.limblecmms.com")) {
   src = demirer;
} else if (checkWhiteLabelDomainMatch("scandinaviandrone.limblecmms.com")) {
   src = scandinaviandrone;
} else if (checkWhiteLabelDomainMatch("comstockfs.limblecmms.com")) {
   src = ComstockFS;
} else if (checkWhiteLabelDomainMatch("harrigan.limblecmms.com")) {
   src = harriganLogo;
} else if (checkWhiteLabelDomainMatch("sentegrity.limblecmms.com")) {
   src = sentegrityLogo;
} else if (checkWhiteLabelDomainMatch("dartbrook.limblecmms.com")) {
   src = dartbrookLogo;
} else if (checkWhiteLabelDomainMatch("redaptive.limblecmms.com")) {
   src = redaptiveLogo;
} else if (checkWhiteLabelDomainMatch("johndeere.limblecmms.com")) {
   src = johndeereLogo;
} else if (checkWhiteLabelDomainMatch("kettering.limblecmms.com")) {
   src = KULogo;
} else if (checkWhiteLabelDomainMatch("homefix.limblecmms.com")) {
   src = homeFixLogo;
} else if (checkWhiteLabelDomainMatch("intelsat.limblecmms.com")) {
   src = intelsat;
} else if (checkWhiteLabelDomainMatch("jbmpackaging.limblecmms.com")) {
   src = jbm;
} else if (checkWhiteLabelDomainMatch("access.limblecmms.com")) {
   src = access;
} else if (checkWhiteLabelDomainMatch("canyonridgeservices.limblecmms.com")) {
   src = canyonRidgeServicesLogo;
} else if (checkWhiteLabelDomainMatch("watermarkcommunitychurch.limblecmms.com")) {
   src = watermarkFacilitiesLogo;
} else if (checkWhiteLabelDomainMatch("oregonfoodbank.limblecmms.com")) {
   src = oregonFoodBankLogo;
} else if (checkWhiteLabelDomainMatch("gbc.limblecmms.com")) {
   src = gbcLogo;
} else if (checkWhiteLabelDomainMatch("tqlfacilities.limblecmms.com")) {
   src = tqlLogoBlack;
}

var logos = document.getElementsByClassName("logo");
for (var i = 0; i < logos.length; ++i) {
   var item = logos[i];
   item.src = src;
}

/*

END OF WHITE LABEL CUSTOMER SECTION

*/

//if remember me is checked then store creds inside of local storage? or maybe not just use secure cookie?

//read the customer's lang cookie and set the front end to foriegn language

/*
   Language Setting
*/
//default setting is english
//Talk to nathan about this maybe? Lang files are pretty big maybe it's better to not load them all on page load

//if not lang cookie then default to english first
// setCookie("languageCookie", "english", 365);
//else read lang cookie and select that language first.
// console.log(getCookie('languageCookie'));
if (!getCookie("languageCookie")) {
   setCookie("languageCookie", "english", 365);
   loadLang("english");
} else {
   let lang = getCookie("languageCookie");
   loadLang(lang);
}

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const error = urlParams.get("error");
const idp = urlParams.get("idp");

if (idp == "true" && getCookie("ssoUsername")) {
   determineSSOProvider(getCookie("ssoUsername")).then(function (answer) {
      window.location.href = answer.data.ssoUrl;
   });
}

document.getElementById("ssoProviderErr").innerHTML = error;

function setFrontEnd() {
   // Due to time constraints, some phrases in esignature verification will not be translated
   if (!isESignatureVerification) {
      setElementAttribute("loginErr", "innerHTML", document.lang.LoginErrorCheckUsernamePassword);
      setElementAttribute("loginBtn", "innerHTML", document.lang.login);
   }

   const loginAttemptNumber = window.sessionStorage.getItem("loginAttemptNumber");
   if (isESignatureVerification && loginAttemptNumber > 0) {
      document.getElementById("loginErr").style.display = "";
      setElementAttribute("loginAttemptNumber", "innerHTML", loginAttemptNumber);
   }

   const languageCookieString = getCookie("languageCookie");
   if (languageCookieString === "english") {
      setElementAttribute(
         "slogan",
         "innerHTML",
         "<span id='empowerTextSwoosh'>Empower<img id='empowerImage' /></span> the unsung heroes that support the world"
      );
   } else {
      setElementAttribute("slogan", "innerHTML", document.lang.EmpowerSlogan);
   }

   setInternationalization();

   document.getElementById("sso").addEventListener("click", enterSSOUsernameManually);
   document.getElementById("forgotMyPasswordBtn").addEventListener("click", forgotPasswordClicked);
   document.getElementById("forgot-back-button").addEventListener("click", backButtonClicked);
   document.getElementById("sso-back-button").addEventListener("click", backButtonClicked);

   const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
   });
   if (params.autofill === "true") {
      setElementAttribute("username", "value", params.username);
      setElementAttribute("ssoUsername", "value", params.userEmail);
   }
}

function setInternationalization() {
   setElementAttribute("empowerImage", "src", swoosh);
   setElementAttribute("forgotMyPasswordBtn", "innerHTML", document.lang.forgotPassword);
   setElementAttribute("rememberMe", "innerHTML", document.lang.rememberMe);
   setElementAttribute(
      "dontHaveAnAccount",
      "innerHTML",
      document.lang.DoesYourCompanyNotHaveAnAccount
   );
   setElementAttribute("email-login-label-text", "innerHTML", document.lang.username);
   setElementAttribute("emailTooltip", "title", document.lang.UsernameLoginTooltip);
   setElementAttribute("password-login-label", "innerHTML", document.lang.password);
   setElementAttribute("forgotMyPasswordUsernameLabel", "innerHTML", document.lang.username);
   setElementAttribute("forgotPwBtn", "innerHTML", document.lang.ResetPassword);
   setElementAttribute(
      "forgotPasswordInstruction",
      "innerHTML",
      document.lang.ForgotPasswordResetInstructions
   );
   setElementAttribute("forgot-back-button", "innerHTML", document.lang.BackToMainPage);
   setElementAttribute("signUpLink", "innerHTML", " " + document.lang.SignUp + " ");
   setElementAttribute("sso-back-button", "innerHTML", document.lang.BackToMainPage);

   setElementAttribute("legalTermsSection", "innerHTML", document.lang.LegalCopy);

   setElementAttribute("pwExpiredOrgPolicy", "innerHTML", document.lang.UpdatePasswordEvery90Days);
   setElementAttribute(
      "pwExpiredLengthWarningText",
      "innerHTML",
      document.lang.yourPasswordMustBeAtLeast + `: 8`
   );
   setElementAttribute("updatePasswordBtn", "innerHTML", document.lang.UpdatePassword);
   setElementAttribute("current-password-label", "innerHTML", document.lang.CurrentPassword);
   setElementAttribute("new-password-label", "innerHTML", document.lang.NewPassword);
   setElementAttribute("repeat-password-label", "innerHTML", document.lang.ConfirmNewPassword);
}

function setElementAttribute(elementId, attribute, value) {
   const element = document.getElementById(elementId);
   if (element) {
      element[attribute] = value;
   }
}

function determineSSOProvider(username) {
   let oauthInteraction = "";
   if (isOAuth) {
      oauthInteraction = window.location.pathname.split("/").pop();
   }

   // Forward the webApp returnUrl (set as a query param on this page) so
   // /ssoLogin can redirect the user back to where they started after an
   // e-signature SSO round-trip.
   const params = new URLSearchParams(window.location.search);
   const returnUrl = params.get("returnUrl") || "";

   return EnvRoutesService.getRoutes().then((routes) => {
      var config = {
         headers: { "Access-Control-Allow-Origin": routes.backendAuthServer },
         withCredentials: true,
      };
      return axios
         .post(
            routes.backendAuthServer + "/checkProvider",
            {
               username,
               isMobile: checkMobile(),
               isLegacyMobileApp: isLegacyMobileApp(),
               oauthInteraction,
               returnUrl,
            },
            config
         )
         .then(function (answer) {
            return answer;
         });
   });
}

function verifyESignatureVerificationToken() {
   return EnvRoutesService.getRoutes().then((routes) => {
      var config = {
         headers: { "Access-Control-Allow-Origin": routes.backendAuthServer },
         withCredentials: true,
      };
      return axios
         .post(routes.backendAuthServer + "/verifyESignatureVerificationToken", {}, config)
         .then(function (answer) {
            return answer;
         });
   });
}

function forgotPasswordClicked() {
   document.getElementById("loginForm").style.display = "none";
   document.getElementById("manualForgotPassword").style.display = "block";

   if (isESignatureVerification) {
      document.getElementById("login-btn-container").style.display = "none";
      document.getElementById("forgot-password-btn-container").style.display = "flex";
      document.getElementById("forgot-password-warning").style.display = "block";
      setElementAttribute("main-title", "innerHTML", "Forgot Password?");
      setElementAttribute(
         "subtitle",
         "innerHTML",
         "Please enter your username to receive an email to reset your password."
      );
   }
}

function backButtonClicked() {
   document.getElementById("loginForm").style.display = "";
   document.getElementById("manualSSOUsername").style.display = "none";
   document.getElementById("manualForgotPassword").style.display = "none";
   document.getElementById("newPwExpired").style.display = "none";
   document.getElementById("updatePasswordMessage").style.display = "none";

   if (isESignatureVerification) {
      document.getElementById("login-btn-container").style.display = "flex";
      document.getElementById("sso-btn-container").style.display = "none";
      document.getElementById("forgot-password-btn-container").style.display = "none";
      document.getElementById("forgot-password-warning").style.display = "none";
      setElementAttribute("main-title", "innerHTML", "Please verify your identity");
      setElementAttribute(
         "subtitle",
         "innerHTML",
         "I verify that I am the author of this signature."
      );
   }
}

function enterSSOUsernameManually() {
   document.getElementById("loginForm").style.display = "none";
   document.getElementById("manualSSOUsername").style.display = "block";
   if (getCookie("ssoUsername")) {
      setElementAttribute("ssoUsername", "value", getCookie("ssoUsername"));
   }
   document.getElementById("ssoUsernameSubmit").addEventListener("click", function () {
      submitSSOUsername();
   });

   if (isESignatureVerification) {
      document.getElementById("login-btn-container").style.display = "none";
      document.getElementById("sso-btn-container").style.display = "flex";
      setElementAttribute("main-title", "innerHTML", "Verify with SSO");
   }
}

function submitSSOUsername() {
   const username = document.getElementById("ssoUsername").value;
   determineSSOProvider(username)
      .then(function (answer) {
         const { ssoUrl, success, eSignatureUseNewFlow } = answer.data;
         if (success) {
            if (isESignatureVerification) {
               handleESignatureSSOLogin(ssoUrl, !!eSignatureUseNewFlow);
               return;
            }

            window.location.href = ssoUrl;
         }
      })
      .catch(function (e) {
         document.getElementById("ssoLoginErr").style.display = "block";
      });
}

function handleESignatureSSOLogin(ssoUrl, useNewFlow) {
   if (useNewFlow) {
      // New flow (gated by `esig-update-202605`): ask the parent webApp to
      // navigate the top window to the IdP. iOS Safari blocks window.open()
      // from cross-origin iframes and ITP prevents the iframe from reading the
      // auth-server cookie set by a popup, so we can't poll for it.
      return EnvRoutesService.getRoutes().then((routes) => {
         window.parent.postMessage(
            { type: "esign-sso-redirect", url: ssoUrl },
            routes.appUrl
         );
      });
   }

   // Legacy flow: pop a window to the IdP and poll for the cookie that the
   // /ssoLogin callback drops on the auth-server domain. Works on Chrome/desktop
   // browsers without ITP restrictions.
   const popup = window.open(ssoUrl, "ssoLogin", "popup=true, width=200, height=200");
   if (!popup) {
      window.alert("Please disable your popup blocker and try again.");
      return;
   }

   return EnvRoutesService.getRoutes().then((routes) => {
      const interval = setInterval(() => {
         const eSignatureVerificationToken = getCookie("eSignatureVerificationToken");
         if (eSignatureVerificationToken) {
            clearInterval(interval);
            popup.close();

            verifyESignatureVerificationToken().then((answer) => {
               delete_cookie("eSignatureVerificationToken", "/");
               window.sessionStorage.removeItem("loginAttemptNumber");
               window.parent.postMessage(
                  {
                     success: answer.data.success,
                     user: answer.data.userID,
                  },
                  routes.appUrl
               );
            });
         }
      }, 1000);
   });
}

document.getElementById("manualSSOUsername").addEventListener(
   "keydown",
   function (event) {
      if (event.key == "Enter") {
         submitSSOUsername();
      }
   },
   false
);

function setCookie(cname, value) {
   var d = new Date();
   d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
   var expires = "expires=" + d.toUTCString();
   if (window.location.hostname.includes("localhost")) {
      delete_cookie(cname, "/", "");
      document.cookie = cname + "=" + value + ";" + expires + ";";
   } else {
      delete_cookie(cname, "/", "limblecmms.com");
      document.cookie = cname + "=" + value + ";" + expires + ";Domain=limblecmms.com";
   }
}
function delete_cookie(name, path, domain) {
   if (getCookie(name)) {
      document.cookie =
         name +
         "=" +
         (path ? ";path=" + path : "") +
         (domain ? ";domain=" + domain : "") +
         ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
   }
}
function getCookie(cname) {
   var name = cname + "=";
   var decodedCookie = decodeURIComponent(document.cookie);
   var ca = decodedCookie.split(";");
   for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
         c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
         return c.substring(name.length, c.length);
      }
   }
   return "";
}

function getCookies(prefixes) {
   var decodedCookie = decodeURIComponent(document.cookie);
   var ca = decodedCookie.split(";");
   var found = [];
   for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
         c = c.substring(1);
      }
      for (var j = 0; j < prefixes.length; j++) {
         if (c.indexOf(prefixes[j]) == 0) {
            var r = c.split("=", 2);
            found[r[0]] = r[1];
            break;
         }
      }
   }
   return found;
}

/**
 * Deletes old cookies that are no longer used.
 */
function deleteUnusedCookies(redirect) {
   var prefixes = [
      "ph_phc", // Pumba / Posthog
   ];

   // temporary until we completely move CDN providers
   if (!/^https:\/\/(?:21cfr-)?app\.limblecmms\.com/.test(redirect)) {
      // clear imperva cookies unless we redirecting to us-prod or 21cfr
      prefixes.push("incap", "visid_incap");
   }

   const cookies = getCookies(prefixes);
   const domains = calculateCookieDomains();

   for (var domain in domains) {
      for (var key in cookies) {
         delete_cookie(key, "/", domain);
      }
   }
}

/**
 * Calculates all possible cookie domains for the current hostname.
 * @returns {Object} An object with all possible cookie domains as keys.
 */
function calculateCookieDomains() {
   var carry = document.location.hostname;
   var domains = {};
   domains[""] = true;

   while (carry.indexOf(".") != carry.lastIndexOf(".")) {
      carry = carry.split(".").slice(1).join(".");
      domains[carry] = true;
   }

   return domains;
}

function loadLang(lang) {
   if (lang == "english") {
      const en = import("../../i18n/en.json");
      en.then(function (en) {
         document.lang = en;
         setFrontEnd();
         setCookie("languageCookie", "english");
      });
   } else if (lang == "estonian") {
      const et = import("../../i18n/et.json");
      et.then(function (et) {
         document.lang = et;
         setCookie("languageCookie", "estonian");
         setFrontEnd();
      });
   } else if (lang == "slovenian") {
      const sl = import("../../i18n/sl.json");
      sl.then(function (sl) {
         document.lang = sl;
         setCookie("languageCookie", "slovenian");
         setFrontEnd();
      });
   } else if (lang == "spanish") {
      const es = import("../../i18n/es.json");
      es.then(function (es) {
         document.lang = es;
         setCookie("languageCookie", "spanish");
         setFrontEnd();
      });
   } else if (lang == "thai") {
      const th = import("../../i18n/th.json");
      th.then(function (th) {
         document.lang = th;
         setCookie("languageCookie", "thai");
         setFrontEnd();
      });
   } else if (lang == "french") {
      const fr = import("../../i18n/fr.json");
      fr.then(function (fr) {
         document.lang = fr;
         setCookie("languageCookie", "french");
         setFrontEnd();
      });
   } else if (lang == "portuguese") {
      const pt = import("../../i18n/pt.json");
      pt.then(function (pt) {
         document.lang = pt;
         setCookie("languageCookie", "portuguese");
         setFrontEnd();
      });
   } else if (lang == "hebrew") {
      const he = import("../../i18n/he.json");
      he.then(function (he) {
         document.lang = he;
         setCookie("languageCookie", "hebrew");
         setFrontEnd();
         document.body.classList.add("rightBodyAlignText");
      });
   } else if (lang == "german") {
      const de = import("../../i18n/de.json");
      de.then(function (de) {
         document.lang = de;
         setCookie("languageCookie", "german");
         setFrontEnd();
      });
   } else if (lang == "chinese") {
      const zh = import("../../i18n/zh.json");
      zh.then(function (zh) {
         document.lang = zh;
         setCookie("languageCookie", "chinese");
         setFrontEnd();
      });
   } else if (lang == "arabic") {
      const ar = import("../../i18n/ar.json");
      ar.then(function (ar) {
         document.lang = ar;
         setCookie("languageCookie", "arabic");
         setFrontEnd();
         document.body.classList.add("rightBodyAlignText");
      });
   } else if (lang == "bulgarian") {
      const bg = import("../../i18n/bg.json");
      bg.then(function (bg) {
         document.lang = bg;
         setCookie("languageCookie", "bulgarian");
         setFrontEnd();
      });
   } else if (lang == "czech") {
      const cs = import("../../i18n/cs.json");
      cs.then(function (cs) {
         document.lang = cs;
         setCookie("languageCookie", "czech");
         setFrontEnd();
      });
   } else if (lang == "farsi") {
      const fa = import("../../i18n/fa.json");
      fa.then(function (fa) {
         document.lang = fa;
         setCookie("languageCookie", "farsi");
         setFrontEnd();
         document.body.classList.add("rightBodyAlignText");
      });
   } else if (lang == "hungarian") {
      const hu = import("../../i18n/hu.json");
      hu.then(function (hu) {
         document.lang = hu;
         setCookie("languageCookie", "hungarian");
         setFrontEnd();
      });
   } else if (lang == "italian") {
      const it = import("../../i18n/it.json");
      it.then(function (it) {
         document.lang = it;
         setCookie("languageCookie", "italian");
         setFrontEnd();
      });
   } else if (lang == "japanese") {
      const ja = import("../../i18n/ja.json");
      ja.then(function (ja) {
         document.lang = ja;
         setCookie("languageCookie", "japanese");
         setFrontEnd();
      });
   } else if (lang == "korean") {
      const ko = import("../../i18n/ko.json");
      ko.then(function (ko) {
         document.lang = ko;
         setCookie("languageCookie", "korean");
         setFrontEnd();
      });
   } else if (lang == "latvian") {
      const lv = import("../../i18n/lv.json");
      lv.then(function (lv) {
         document.lang = lv;
         setCookie("languageCookie", "latvian");
         setFrontEnd();
      });
   } else if (lang == "dutch") {
      const nl = import("../../i18n/nl.json");
      nl.then(function (nl) {
         document.lang = nl;
         setCookie("languageCookie", "dutch");
         setFrontEnd();
      });
   } else if (lang == "norwegian") {
      const no = import("../../i18n/no.json");
      no.then(function (no) {
         document.lang = no;
         setCookie("languageCookie", "norwegian");
         setFrontEnd();
      });
   } else if (lang == "indonesian") {
      const no = import("../../i18n/id.json");
      no.then(function (no) {
         document.lang = no;
         setCookie("languageCookie", "indonesian");
         setFrontEnd();
      });
   } else if (lang == "polish") {
      const pl = import("../../i18n/pl.json");
      pl.then(function (pl) {
         document.lang = pl;
         setCookie("languageCookie", "polish");
         setFrontEnd();
      });
   } else if (lang == "romanian") {
      const ro = import("../../i18n/ro.json");
      ro.then(function (ro) {
         document.lang = ro;
         setCookie("languageCookie", "romanian");
         setFrontEnd();
      });
   } else if (lang == "russian") {
      const ru = import("../../i18n/ru.json");
      ru.then(function (ru) {
         document.lang = ru;
         setCookie("languageCookie", "russian");
         setFrontEnd();
      });
   } else if (lang == "swedish") {
      const sv = import("../../i18n/sv.json");
      sv.then(function (sv) {
         document.lang = sv;
         setCookie("languageCookie", "swedish");
         setFrontEnd();
      });
   } else if (lang == "swahili") {
      const sw = import("../../i18n/sw.json");
      sw.then(function (sw) {
         document.lang = sw;
         setCookie("languageCookie", "swahili");
         setFrontEnd();
      });
   } else if (lang == "tagalog") {
      const tl = import("../../i18n/tl.json");
      tl.then(function (tl) {
         document.lang = tl;
         setCookie("languageCookie", "tagalog");
         setFrontEnd();
      });
   } else if (lang == "tajik") {
      const tg = import("../../i18n/tg.json");
      tg.then(function (tg) {
         document.lang = tg;
         setCookie("languageCookie", "tajik");
         setFrontEnd();
      });
   } else if (lang == "turkish") {
      const tr = import("../../i18n/tr.json");
      tr.then(function (tr) {
         document.lang = tr;
         setCookie("languageCookie", "turkish");
         setFrontEnd();
      });
   } else if (lang == "vietnamese") {
      const vi = import("../../i18n/vi.json");
      vi.then(function (vi) {
         document.lang = vi;
         setCookie("languageCookie", "vietnamese");
         setFrontEnd();
      });
   } else if (lang == "bengali") {
      const bn = import("../../i18n/bn.json");
      bn.then(function (bn) {
         document.lang = bn;
         setCookie("languageCookie", "bengali");
         setFrontEnd();
      });
   } else if (lang == "hindi") {
      const hi = import("../../i18n/hi.json");
      hi.then(function (hi) {
         document.lang = hi;
         setCookie("languageCookie", "hindi");
         setFrontEnd();
      });
   } else if (lang == "traditional-chinese"){
      const zh = import("../../i18n/zh-TW.json");
      zh.then(function (zh) {
         document.lang = zh;
         setCookie("languageCookie", "traditional-chinese");
         setFrontEnd();
      });
   }
    else {
      const en = import("../../i18n/en.json");
      en.then(function (en) {
         document.lang = en;
         setFrontEnd();
         setCookie("languageCookie", "english");
      });
   }
}
// function setLang() {
// 	var selectBox = document.getElementById('lang');
// 	var selectedValue = selectBox.options[selectBox.selectedIndex].value;
// 	if (selectedValue == 'english') {
// 		loadLang('english');
// 	} else if (selectedValue == 'spanish') {
// 		loadLang('spanish');
// 	} else if (selectedValue == 'thai') {
// 		loadLang('thai');
// 	} else if (selectedValue == 'french') {
// 		loadLang('french');
// 	} else if (selectedValue == 'portuguese') {
// 		loadLang('portuguese');
// 	} else if (selectedValue == 'hebrew') {
// 		loadLang('hebrew');
// 	}
// }
// document.setLang = setLang;
/*
General Use functions
*/

function checkMobile() {
   if (isLegacyMobileApp()) {
      return true;
   }

   if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true;
   }

   let mobile = new RegExp("m=true").test(window.location.href);
   if (mobile) {
      return true;
   }

   return false;
}
/**
 * Packaged Limble app built with Median (formerly GoNative).
 * Default UA suffixes per https://docs.median.co/docs/detecting-app-usage:
 *   legacy: GoNativeIOS/1.0 gonative | GoNativeAndroid/1.0 gonative
 *   newer:  MedianIOS/1.0 median    | MedianAndroid/1.0 median
 * Custom UA strings in Median App Studio are not detectable here.
 */
function isLegacyMobileApp() {
   const ua = navigator.userAgent;
   return /gonative/i.test(ua) || /medianios|medianandroid/i.test(ua);
}
function isAndroid() {
   return /Android/i.test(navigator.userAgent);
}
function evaluateRedirectUri(responseRedirectUri) {
   return checkMobile() === true
      ? createMobileRedirectUri(responseRedirectUri)
      : responseRedirectUri;
}
function createMobileRedirectUri(responseRedirectUri) {
   const url = new URL(responseRedirectUri);
   const baseUrl = url.origin;
   const mobileDashboardUrl = baseUrl + MOBILE_REDIRECT_ROUTE;
   return mobileDashboardUrl;
}
function navigateToApp(redirectUrl) {
   if (isAndroid()) {
      window.location.replace(redirectUrl);
   } else {
      window.location.href = redirectUrl;
   }
}
function setLoginLocalStorage(username, password) {
   if (username) {
      localStorage.setItem(userField, btoa(username));
   }
   if (password) {
      localStorage.setItem(passField, btoa(password));
   }

   return true;
}

function getLoginLocalStorage(userField, passField) {
   if (getCookie("email") != null && getCookie("password") != null) {
      setLoginLocalStorage(getCookie("email"), getCookie("password"));
   }

   // console.log(userField);
   let user = localStorage.getItem(userField);
   let pass = localStorage.getItem(passField);

   if (user == null || pass == null) {
      return { user, pass };
   } else {
      return { user: atob(user), pass: atob(pass) };
   }
}

function clearLoginLocalStorage(userField, passField) {
   localStorage.removeItem(userField);
   localStorage.removeItem(passField);

   return true;
}

//Hide signup stuff from IOS because Apple is a pain.
if (navigator.userAgent.includes("iPhone")) {
   document.getElementById("signUpDiv").style.display = "none";
}

const togglePassword = document.querySelector("#togglePassword");
const password = document.querySelector("#password");

togglePassword.addEventListener("click", function (e) {
   // toggle the type attribute
   const type = password.getAttribute("type") === "password" ? "text" : "password";
   password.setAttribute("type", type);
   // toggle the eye slash icon
   this.classList.toggle("fa-eye-slash");
   this.classList.toggle("fa-eye");
});

// ESignatureVerification needs to let the parent know about sso logins
// if (isESignatureVerification) {
//    const params = new Proxy(new URLSearchParams(window.location.search), {
//       get: (searchParams, prop) => searchParams.get(prop),
//    });

//    if (params.error) {
//       window.parent.postMessage(
//          {
//             success: false,
//             user: 0
//          },
//          routes.appUrl
//       );
//       return;
//    }

//    if (params.sso === "true") {
//       const eSignatureVerificationToken = params.eSignatureVerificationToken;
//       const eSignatureVerificationTokenCookie = getCookie("eSignatureVerificationToken");

//       if (eSignatureVerificationToken === eSignatureVerificationTokenCookie) {
//          delete_cookie("eSignatureVerificationToken", "/", "window.location.hostname");
//          window.parent.postMessage(
//             {
//                success: true,
//                user: params.userID
//             },
//             routes.appUrl
//          );
//       }
//    }
// }
